export const getAge = (inputDate) => {
  if (!inputDate) return null;
  const today = new Date();
  const birthDate = new Date(inputDate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
export const calculateAgesAndFlags = (dates = []) => {
  return dates.map((date) => {
    const age = getAge(date);
    return {
      age,
      ageFlag: age < 18 || age > 60
    };
  });
};


const AgeCalcUtils = {
  getAge,
  calculateAgesAndFlags,
};
export default AgeCalcUtils;